exports.SHIPMENT_TYPE = {
  DOMESTIC: 0,
  REVERSE_IT: 1,
  SWAP_IT: 2,
  PARCELNET: 3,
  EU: 4,
  INTERNATIONAL: 5,
  DPD_DIRECT_EU: 6,
  DPD_DIRECT_INTERNATIONAL: 7,
  HERMES_RETURN: 8,
  TYPE_10: 10, // TODO: rename when would be known
};

exports.ADDRESS_TYPE = {
  DELIVERY: 0,
  RETURN: 1,
};
